import type { SxProps, Theme } from '@mui/material'

export const styles = {
  // Figma: stacked variable sections sit ~16px apart (wider than the row
  // content's 8px block gap).
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
} satisfies Record<string, SxProps<Theme>>
